import { sprintf } from 'sprintf-js';

function Translator() {
  this._translations = {};
  this._languages = {};
  this._activeLanguage = 'EN';
  this._undefinedMap = {};
}

Translator.prototype.RegisterLanguage = function(langCode, nativeLabel, translations) {
  if (typeof langCode === "string" && typeof nativeLabel === "string" && typeof translations === "object") {
    this._translations[langCode.toUpperCase()] = translations;
    this._languages[langCode.toUpperCase()] = nativeLabel;
  }
};

Translator.prototype.ListLanguages = function() {
  return {...{'EN': 'English'}, ...this._languages};
};

Translator.prototype.SetActiveLanguage = function(language) {
  if (typeof language === "string" && language in this._languages) {
    this._activeLanguage = language.toUpperCase()
  } else {
    this._activeLanguage = null; // Default to English
  }
};

Translator.prototype.GetActiveLanguage = function() {
  return this._activeLanguage;
};

Translator.prototype.SetLanguageMap = function(map) {
  if (typeof map === "object") {
    this._undefinedMap = map;
  }
};

Translator.prototype.Translate = function() {
  let arr = Array.from(arguments);

  if (arr.length === 0) {
    return arr;
  }

  let langCode = this._activeLanguage;

  if (langCode !== null && langCode in this._translations === false) {
    if (langCode in this._undefinedMap) {
      if (this._undefinedMap[langCode] in this._translations) {
        langCode = this._translations[this._undefinedMap[langCode]]
      }
    }
  }

  if (langCode !== null && langCode in this._translations) {
    if (arr[0] in this._translations[langCode]) {
      arr[0] = this._translations[langCode][arr[0]];
      return arr;
    } else {
      if (langCode in this._undefinedMap && this._translations[this._undefinedMap[langCode]]) {
        if (arr[0] in this._translations[this._undefinedMap[langCode]]) {
          arr[0] = this._translations[this._undefinedMap[langCode]][arr[0]];
          return arr;
        }
      }
    }
  }

  return arr;
};

let translationCollector = {};
let record = -1;

window.i18nRecordAll = function() {
  record = 0;
  translationCollector = {};
  console.debug("i18n: recording all translations")
};

window.i18nRecordUntranslated = function() {
  record = 1;
  translationCollector = {};
  console.debug("i18n: recording untranslated only")
};

window.i18nPrintRecorded = function() {
  console.log(JSON.stringify(translationCollector, null, 2));
};

Translator.prototype.T = function(args) {
  let result = this.Translate.apply(this, args);

  if (args.length > 0) {
    switch (record) {
      case 0:
        translationCollector[args[0]] = result[0];
        break;
      case 1:
        if (args[0] === result[0]) {
          translationCollector[args[0]] = result[0];
        }
        break;
    }
  }

  return sprintf.apply(null, result);
};

export default new Translator();



// WEBPACK FOOTER //
// ./src/plugins/i18n.js